import { render, staticRenderFns } from "./TrackProjetos.vue?vue&type=template&id=0b08d084&scoped=true&"
import script from "./TrackProjetos.vue?vue&type=script&lang=ts&"
export * from "./TrackProjetos.vue?vue&type=script&lang=ts&"
import style0 from "./TrackProjetos.vue?vue&type=style&index=0&id=0b08d084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08d084",
  null
  
)

export default component.exports